import React from "react";
import { CircleFlag } from "react-circle-flags";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../redux/store";
import { selectCommonSettings } from "../../../util/selectors";

const DeliveredTo = ({ cityLabel }: { cityLabel?: string }) => {
  const { t } = useTranslation("productDetails");
  const commonSettings = useAppSelector(selectCommonSettings);

  return (
    <div className="applePay_card_wrapper">
      <div className="applePay_card selectedCountry">
        <span className="floatedTxt">{t("deliverTo")}</span>
        <div className="country_section">
          <CircleFlag
            countryCode={commonSettings.countrySHORT.toLowerCase()}
            className="country_flag_img"
          />
          <span>{`${commonSettings?.countryName}${cityLabel ? "," : ""}`}</span>

          {cityLabel && <span className="delivery_city">{cityLabel}</span>}
        </div>
      </div>
    </div>
  );
};

export default DeliveredTo;
